import { createContext, useContext } from "react";
import { getConfiguration } from '../../data/utils/configuration';
import { parseLiveData } from "../../data/parseLiveData";
import { usePoll } from "../../data/fetch/useFetch";
import LiveLoader from "../../live/LiveLoader";

export const SearchLiveDataContext = createContext(null);

export function useSearchLiveData() {
  return useContext(SearchLiveDataContext);
}

export default function SearchLiveDataProvider({ children }) {
  const conf = getConfiguration();

  const [, isError, data] = usePoll(
    conf.api.getMenuLiveSingleMatchPage,
    null,
    (rawData) => parseLiveData(rawData)
  );

  if (isError) {
    return <LiveLoader isError={true} />;
  }

  return (
    <SearchLiveDataContext.Provider value={data}>
      {children}
    </SearchLiveDataContext.Provider>
  );
}
